import { createBrowserRouter } from 'react-router-dom';

type GlobalRouter = ReturnType<typeof createBrowserRouter>;

// workaround to access router in saga
export let globalRouter: GlobalRouter;

export const setGlobalRouter = (router) => {
  globalRouter = router;
};
